import { render } from "./FeatherLogOutSvg.vue?vue&type=template&id=7782d6d4"
const script = {}
script.render = render

export default script